var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M20.405 5.738A11.9 11.9 0 0 0 1.687 20.089L0 26.25l6.305-1.655a11.857 11.857 0 0 0 5.684 1.446h.005A12.007 12.007 0 0 0 24 14.148a11.94 11.94 0 0 0-3.595-8.411zm-8.411 18.3a9.867 9.867 0 0 1-5.036-1.377l-.358-.215-3.739.98 1-3.648-.24-.378a9.9 9.9 0 1 1 18.37-5.255 10 10 0 0 1-9.996 9.893zm5.421-7.4c-.295-.15-1.757-.868-2.03-.964s-.471-.15-.67.15-.766.964-.943 1.168-.348.225-.643.075a8.089 8.089 0 0 1-4.045-3.536c-.305-.525.305-.487.873-1.623a.551.551 0 0 0-.027-.52c-.075-.15-.67-1.613-.916-2.207-.241-.579-.488-.5-.67-.509s-.37-.011-.568-.011a1.1 1.1 0 0 0-.793.37 3.339 3.339 0 0 0-1.039 2.48 5.822 5.822 0 0 0 1.211 3.075 13.279 13.279 0 0 0 5.079 4.489c1.886.814 2.625.884 3.568.745a3.044 3.044 0 0 0 2-1.414 2.485 2.485 0 0 0 .171-1.414c-.064-.138-.262-.213-.557-.358z",
    transform: "translate(0 -2.25)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/whatsApp.30f631c149cfc82f54ad2a02b82b2231.svg";
export { ForwardRef as ReactComponent };